export enum MembershipPlanEnum {
  'BUY AS YOU FLY',
  'RISE',
  'SELECT',
  'SIGNATURE',
  'ELITE',
}
